import { render, staticRenderFns } from "./HistoryInnerChat.vue?vue&type=template&id=d6412f36&scoped=true"
import script from "./HistoryInnerChat.vue?vue&type=script&lang=js"
export * from "./HistoryInnerChat.vue?vue&type=script&lang=js"
import style0 from "./HistoryInnerChat.vue?vue&type=style&index=0&id=d6412f36&prod&lang=css"
import style1 from "./HistoryInnerChat.vue?vue&type=style&index=1&id=d6412f36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6412f36",
  null
  
)

export default component.exports